import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import cn from 'classnames'
import Image from '../Image'
import { CustomerContext } from '../../contexts/CustomerContext'
import OrderPackage from '../../models/OrderPackage'
import useLocalStorage from '../../hooks/useLocalStorage'
import styles from './PackageCardV2.module.sass'

const PackageCardV2 = ({ packageItem, to }) => {
  const { id, name, bannerUrl, imageUrl, useNewPackageBuilder } = packageItem
  const { customer, setCustomer } = useContext(CustomerContext)
  const history = useHistory()
  const [isUsingAccessCode] = useLocalStorage('isUsingAccessCode')

  const handleSelection = () => {
    if (!customer.cart) return
    const orderPackage = new OrderPackage({
      packageId: id,
      cartId: customer.cart.id,
      isPreviewHidden: !isUsingAccessCode,
    })
    setCustomer({ ...customer, currentOrderPackage: orderPackage })
    history.push(to)
  }

  const cardImage = useNewPackageBuilder ? bannerUrl : imageUrl

  return (
    <div className={cn('seniors-package-card', styles.card)}>
      {cardImage && (
        <div className={styles.imageWrap}>
          <Image alt={name} src={cardImage} />
        </div>
      )}
      <h3 className={cn('seniors-package-card__name', styles.name)}>{name}</h3>
      <div className={styles.actionRow}>
        <button
          type="button"
          className={cn('seniors-btn', 'seniors-btn--outline', styles.selectBtn)}
          onClick={handleSelection}
        >
          Select
        </button>
      </div>
    </div>
  )
}

export default PackageCardV2
